import { render, staticRenderFns } from "./dropdown-item.vue?vue&type=template&id=f9d9c93e&"
import script from "./dropdown-item.vue?vue&type=script&lang=js&"
export * from "./dropdown-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9d9c93e')) {
      api.createRecord('f9d9c93e', component.options)
    } else {
      api.reload('f9d9c93e', component.options)
    }
    module.hot.accept("./dropdown-item.vue?vue&type=template&id=f9d9c93e&", function () {
      api.rerender('f9d9c93e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dropdown/dropdown-item.vue"
export default component.exports